// Generated by CoffeeScript 2.5.1

import './App.css';
import MainView from './MainView';
import React, { Component } from 'react';
;
var App,
  boundMethodCheck = function(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new Error('Bound instance method accessed before binding'); } };

App = class App extends Component {
  constructor(props) {
    super(props);
    this.onValue = this.onValue.bind(this);
    this.state = {
      value: 50
    };
    return;
  }

  onValue(v) {
    boundMethodCheck(this, App);
    return this.setState({
      value: v
    });
  }

  render() {
    return <div className="App">
      <MainView value={this.state.value} app={this} />
    </div>;
  }

};

export default App;
